import { createAction, props } from '@ngrx/store';
import { Location } from '@fantaz/shared/data-access/models';

export const loadLocation = createAction('[Location Page] Load Location');

export const checkLocationPermission = createAction(
  '[Location Page] Location Permission',
);

export const loadLocationSuccess = createAction(
  '[Location/API] Load Location Success',
  props<{
    location: Location | null;
    userAllowToUseFallbackLocation: boolean;
  }>(),
);

export const loadLocationFailure = createAction(
  '[Location/API] Load Location Failure',
  props<{ error: any }>(),
);

export const verifyCashPlayStatus = createAction(
  '[Location Page] Verify Cash Play Status',
  props<{ location: Location }>(),
);

export const verifyCashPlayStatusSuccess = createAction(
  '[Location/API] Verify Cash Play Status Success',
  props<{ blocked: boolean }>(),
);

export const verifyCashPlayStatusFailure = createAction(
  '[Location/API] Verify Cash Play Status Failure',
  props<{ error: any }>(),
);
